!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e(require("react"));else if ("function" == typeof define && define.amd) define(["React"], e);else {
    var n = "object" == typeof exports ? e(require("react")) : e(t.React);

    for (var r in n) {
      ("object" == typeof exports ? exports : t)[r] = n[r];
    }
  }
}(window, function (t) {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "/dist/", n(n.s = 8);
  }([function (t, e, n) {
    var r = n(7);
    "string" == typeof r && (r = [[t.i, r, ""]]);
    n(3)(r, {
      hmr: !1,
      transform: void 0,
      insertInto: void 0
    }), r.locals && (t.exports = r.locals);
  }, function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    var r = n(5);
    "string" == typeof r && (r = [[t.i, r, ""]]);
    n(3)(r, {
      hmr: !1,
      transform: void 0,
      insertInto: void 0
    }), r.locals && (t.exports = r.locals);
  }, function (t, e, n) {
    var r,
        o,
        a = {},
        i = (r = function r() {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === o && (o = r.apply(this, arguments)), o;
    }),
        s = function (t) {
      var e = {};
      return function (t) {
        if ("function" == typeof t) return t();

        if (void 0 === e[t]) {
          var n = function (t) {
            return document.querySelector(t);
          }(t);

          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (t) {
            n = null;
          }
          e[t] = n;
        }

        return e[t];
      };
    }(),
        f = null,
        c = 0,
        u = [],
        p = n(6);

    function l(t, e) {
      for (var n = 0; t.length > n; n++) {
        var r = t[n],
            o = a[r.id];

        if (o) {
          o.refs++;

          for (var i = 0; o.parts.length > i; i++) {
            o.parts[i](r.parts[i]);
          }

          for (; r.parts.length > i; i++) {
            o.parts.push(b(r.parts[i], e));
          }
        } else {
          var s = [];

          for (i = 0; r.parts.length > i; i++) {
            s.push(b(r.parts[i], e));
          }

          a[r.id] = {
            id: r.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function d(t, e) {
      for (var n = [], r = {}, o = 0; t.length > o; o++) {
        var a = t[o],
            i = e.base ? a[0] + e.base : a[0],
            s = {
          css: a[1],
          media: a[2],
          sourceMap: a[3]
        };
        r[i] ? r[i].parts.push(s) : n.push(r[i] = {
          id: i,
          parts: [s]
        });
      }

      return n;
    }

    function h(t, e) {
      var n = s(t.insertInto);
      if (!n) throw Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = u[u.length - 1];
      if ("top" === t.insertAt) r ? r.nextSibling ? n.insertBefore(e, r.nextSibling) : n.appendChild(e) : n.insertBefore(e, n.firstChild), u.push(e);else if ("bottom" === t.insertAt) n.appendChild(e);else {
        if ("object" != typeof t.insertAt || !t.insertAt.before) throw Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = s(t.insertInto + " " + t.insertAt.before);
        n.insertBefore(e, o);
      }
    }

    function m(t) {
      if (null === t.parentNode) return !1;
      t.parentNode.removeChild(t);
      var e = u.indexOf(t);
      0 > e || u.splice(e, 1);
    }

    function v(t) {
      var e = document.createElement("style");
      return void 0 === t.attrs.type && (t.attrs.type = "text/css"), y(e, t.attrs), h(t, e), e;
    }

    function y(t, e) {
      Object.keys(e).forEach(function (n) {
        t.setAttribute(n, e[n]);
      });
    }

    function b(t, e) {
      var n, r, o, a;

      if (e.transform && t.css) {
        if (!(a = e.transform(t.css))) return function () {};
        t.css = a;
      }

      if (e.singleton) {
        var i = c++;
        n = f || (f = v(e)), r = S.bind(null, n, i, !1), o = S.bind(null, n, i, !0);
      } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (t) {
        var e = document.createElement("link");
        return void 0 === t.attrs.type && (t.attrs.type = "text/css"), t.attrs.rel = "stylesheet", y(e, t.attrs), h(t, e), e;
      }(e), r = function (t, e, n) {
        var r = n.css,
            o = n.sourceMap,
            a = void 0 === e.convertToAbsoluteUrls && o;
        (e.convertToAbsoluteUrls || a) && (r = p(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
        var i = new Blob([r], {
          type: "text/css"
        }),
            s = t.href;
        t.href = URL.createObjectURL(i), s && URL.revokeObjectURL(s);
      }.bind(null, n, e), o = function o() {
        m(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = v(e), r = function (t, e) {
        var n = e.css,
            r = e.media;
        if (r && t.setAttribute("media", r), t.styleSheet) t.styleSheet.cssText = n;else {
          for (; t.firstChild;) {
            t.removeChild(t.firstChild);
          }

          t.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), o = function o() {
        m(n);
      });

      return r(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          r(t = e);
        } else o();
      };
    }

    t.exports = function (t, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = i()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var n = d(t, e);
      return l(n, e), function (t) {
        for (var r = [], o = 0; n.length > o; o++) {
          (i = a[n[o].id]).refs--, r.push(i);
        }

        for (t && l(d(t, e), e), o = 0; r.length > o; o++) {
          var i;

          if (0 === (i = r[o]).refs) {
            for (var s = 0; i.parts.length > s; s++) {
              i.parts[s]();
            }

            delete a[i.id];
          }
        }
      };
    };

    var g,
        w = (g = [], function (t, e) {
      return g[t] = e, g.filter(Boolean).join("\n");
    });

    function S(t, e, n, r) {
      var o = n ? "" : r.css;
      if (t.styleSheet) t.styleSheet.cssText = w(e, o);else {
        var a = document.createTextNode(o),
            i = t.childNodes;
        i[e] && t.removeChild(i[e]), i.length ? t.insertBefore(a, i[e]) : t.appendChild(a);
      }
    }
  }, function (t, e) {
    t.exports = function (t) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var n = function (t, e) {
            var n = t[1] || "",
                r = t[3];
            if (!r) return n;

            if (e && "function" == typeof btoa) {
              var o = "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */",
                  a = r.sources.map(function (t) {
                return "/*# sourceURL=" + r.sourceRoot + t + " */";
              });
              return [n].concat(a).concat([o]).join("\n");
            }

            return "" + n;
          }(e, t);

          return e[2] ? "@media " + e[2] + "{" + n + "}" : n;
        }).join("");
      }, e.i = function (t, n) {
        "string" == typeof t && (t = [[null, t, ""]]);

        for (var r = {}, o = 0; this.length > o; o++) {
          var a = this[o][0];
          "number" == typeof a && (r[a] = !0);
        }

        for (o = 0; t.length > o; o++) {
          var i = t[o];
          "number" == typeof i[0] && r[i[0]] || (n && !i[2] ? i[2] = n : n && (i[2] = "(" + i[2] + ") and (" + n + ")"), e.push(i));
        }
      }, e;
    };
  }, function (t, e, n) {
    (e = t.exports = n(4)(!1)).push([t.i, ".step-wizard_2cyMY{position:relative;min-height:400px}.step_2fNHT{width:100%;animation-duration:.6s}.hide_1cbGo{display:none}", ""]), e.locals = {
      "step-wizard": "step-wizard_2cyMY",
      step: "step_2fNHT",
      hide: "hide_1cbGo"
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw Error("fixUrls requires window.location");
      if (!t || "string" != typeof t) return t;
      var n = e.protocol + "//" + e.host,
          r = n + e.pathname.replace(/\/[^\/]*$/, "/");
      return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
        var o,
            a = e.trim().replace(/^"(.*)"$/, function (t, e) {
          return e;
        }).replace(/^'(.*)'$/, function (t, e) {
          return e;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? t : (o = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? n + a : r + a.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (t, e, n) {
    (e = t.exports = n(4)(!1)).push([t.i, ".animated_1zLwO{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}@-webkit-keyframes fadeInRight_1MR-6{0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInRight_1MR-6{0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInRight_1MR-6{-webkit-animation-name:fadeInRight_1MR-6;animation-name:fadeInRight_1MR-6}@-webkit-keyframes fadeInLeft_19q5k{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInLeft_19q5k{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInLeft_19q5k{-webkit-animation-name:fadeInLeft_19q5k;animation-name:fadeInLeft_19q5k}@-webkit-keyframes fadeOutRight_3CHf8{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes fadeOutRight_3CHf8{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.fadeOutRight_3CHf8{-webkit-animation-name:fadeOutRight_3CHf8;animation-name:fadeOutRight_3CHf8}@-webkit-keyframes fadeOutLeft_1uIFY{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes fadeOutLeft_1uIFY{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.fadeOutLeft_1uIFY{-webkit-animation-name:fadeOutLeft_1uIFY;animation-name:fadeOutLeft_1uIFY}", ""]), e.locals = {
      animated: "animated_1zLwO",
      fadeInRight: "fadeInRight_1MR-6",
      fadeInLeft: "fadeInLeft_19q5k",
      fadeOutRight: "fadeOutRight_3CHf8",
      fadeOutLeft: "fadeOutLeft_1uIFY"
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "default", function () {
      return m;
    }), n.d(e, "Step", function () {
      return v;
    });
    var r = n(1),
        o = n.n(r),
        a = n(0),
        i = n.n(a),
        s = n(2),
        f = n.n(s);

    function c(t) {
      return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function u(t, e) {
      for (var n = 0; e.length > n; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function p(t) {
      return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function l(t, e) {
      return (l = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function d(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function h(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var m = function (t) {
      function e(t) {
        var n, r;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this, r = p(e).call(this, t), h(d(d(n = !r || "object" !== c(r) && "function" != typeof r ? d(this) : r)), "initialState", function () {
          var t = {
            activeStep: 0,
            classes: {},
            hashKeys: {},
            transitions: n.props.transitions || {
              enterRight: "".concat(i.a.animated, " ").concat(i.a.fadeInRight),
              enterLeft: "".concat(i.a.animated, " ").concat(i.a.fadeInLeft),
              exitRight: "".concat(i.a.animated, " ").concat(i.a.fadeOutRight),
              exitLeft: "".concat(i.a.animated, " ").concat(i.a.fadeOutLeft)
            }
          };
          t.transitions.intro = "";
          var e = n.getHash();
          n.props.children.forEach(function (e, n) {
            t.hashKeys[n] = e.props.hashKey || "step".concat(n + 1), t.hashKeys[t.hashKeys[n]] = n, t.classes[n] = f.a.hide;
          });
          var r = n.props.initialStep - 1;
          return r && n.props.children[r] && (t.activeStep = r), n.props.isHashEnabled && e && void 0 !== t.hashKeys[e] && (t.activeStep = t.hashKeys[e]), t.classes[t.activeStep] = t.transitions.intro, t;
        }), h(d(d(n)), "getHash", function () {
          return decodeURI(window.location.hash).replace(/^#/, "");
        }), h(d(d(n)), "onHashChange", function () {
          var t = n.state.hashKeys[n.getHash()];
          void 0 !== t && n.setActiveStep(t);
        }), h(d(d(n)), "isInvalidStep", function (t) {
          return 0 > t || t >= n.props.children.length;
        }), h(d(d(n)), "setActiveStep", function (t) {
          var e = n.state.activeStep;
          if (e !== t) if (n.isInvalidStep(t)) console.error("".concat(t + 1, " is an invalid step"));else {
            var r = n.state,
                o = r.classes,
                a = r.transitions;
            t > e ? (o[e] = "".concat(f.a.hide, " ").concat(a.exitLeft), o[t] = a.enterRight) : (o[e] = "".concat(f.a.hide, " ").concat(a.exitRight), o[t] = a.enterLeft), n.setState({
              activeStep: t,
              classes: o
            }, function () {
              n.onStepChange({
                previousStep: e + 1,
                activeStep: t + 1
              });
            });
          }
        }), h(d(d(n)), "onStepChange", function (t) {
          n.props.onStepChange(t), n.props.isHashEnabled && n.updateHash(n.state.activeStep);
        }), h(d(d(n)), "firstStep", function () {
          return n.goToStep(1);
        }), h(d(d(n)), "lastStep", function () {
          return n.goToStep(n.props.children.length);
        }), h(d(d(n)), "nextStep", function () {
          return n.setActiveStep(n.state.activeStep + 1);
        }), h(d(d(n)), "previousStep", function () {
          return n.setActiveStep(n.state.activeStep - 1);
        }), h(d(d(n)), "goToStep", function (t) {
          return n.setActiveStep(t - 1);
        }), h(d(d(n)), "updateHash", function (t) {
          window.location.hash = n.state.hashKeys[t];
        }), n.state = n.initialState(), t.isHashEnabled && (window.onhashchange = n.onHashChange), n;
      }

      var n, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && l(t, e);
      }(e, r.Component), n = e, (a = [{
        key: "render",
        value: function value() {
          var t = this,
              e = {
            currentStep: this.state.activeStep + 1,
            totalSteps: this.props.children.length,
            nextStep: this.nextStep,
            previousStep: this.previousStep,
            goToStep: this.goToStep,
            firstStep: this.firstStep,
            lastStep: this.lastStep
          },
              n = this.state.classes,
              r = o.a.Children.map(this.props.children, function (r, a) {
            return e.isActive = a === t.state.activeStep, e.transitions = n[a], !t.props.isLazyMount || t.props.isLazyMount && e.isActive ? o.a.createElement(v, e, o.a.cloneElement(r, e)) : null;
          });
          return o.a.createElement("div", {
            className: f.a["step-wizard"]
          }, this.props.nav && o.a.cloneElement(this.props.nav, e), r);
        }
      }]) && u(n.prototype, a), e;
    }();

    m.defaultProps = {
      children: [],
      initialStep: 1,
      isHashEnabled: !1,
      isLazyMount: !1,
      nav: null,
      onStepChange: function onStepChange() {},
      transitions: void 0
    };

    var v = function v(t) {
      var e = t.children,
          n = t.transitions;
      return o.a.createElement("div", {
        className: "".concat(f.a.step, " ").concat(n)
      }, e);
    };

    v.defaultProps = {
      children: [],
      transitions: ""
    };
  }]);
});